import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledTitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900]
}));
const StyledBodyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700]
}));
const DurationText = styled("span")(({ theme }) => ({
  fontWeight: "bold",
  color: theme.palette.grey[700]
}));
export {
  DurationText,
  StyledBodyText,
  StyledTitleText
};
